import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Hero.css';

const Hero = () => {
  const { t } = useTranslation();
  const [imageLoaded, setImageLoaded] = useState(false);
  const [contentVisible, setContentVisible] = useState(false);

  useEffect(() => {
    // Small delay to ensure smooth initial render
    const timer = setTimeout(() => {
      setContentVisible(true);
    }, 50);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="hero">
      <div className="hero-background">
        <div className="glow-orb glow-orb-1"></div>
        <div className="glow-orb glow-orb-2"></div>
        <div className="glow-orb glow-orb-3"></div>
        <div className="glow-orb glow-orb-4"></div>
      </div>
      
      <div className={`hero-container ${contentVisible ? 'hero-container-visible' : ''}`}>
        <div className="hero-content">
          <h1>{t('hero.title')}</h1>
          <p>{t('hero.subtitle')}</p>
          
          <div className="hero-buttons">
            <Link to="/services" className="btn btn-primary">
              {t('hero.solutions')}
            </Link>
            <Link to="/contact" className="btn btn-secondary">
              {t('hero.learnMore')}
            </Link>
          </div>

          <div className="hero-stats">
            <div className="stats-divider"></div>
            <div className="stats-container">
              <div className="stat-item">
                <div className="stat-number">5+</div>
                <div className="stat-label">{t('hero.globalClients')}</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">10+</div>
                <div className="stat-label">{t('hero.successfulProjects')}</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">15+</div>
                <div className="stat-label">{t('hero.yearsExperience')}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="hero-visual">
          <div className={`hero-image-wrapper ${imageLoaded ? 'hero-image-loaded' : ''}`}>
            <img 
              src={require('../assets/sap.png')} 
              alt="SAP" 
              className="hero-sap-logo"
              onLoad={() => setImageLoaded(true)}
              loading="eager"
              width="600"
              height="338"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
